/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import type { ConnectionType } from 'embercom/objects/environments/connection-types';

export default class Connection extends Model {
  @attr('number') declare connectionType: ConnectionType;
  @attr('string') declare externalIdentifier: string;
  @attr('number') declare environmentId: number;
  @attr('string') declare environmentDisplayName: string;
  @attr('boolean') declare productionConnection: boolean;
  @attr('boolean') declare defaultConnection: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'standalone/connection': Connection;
  }
}
